import { render } from "./AllProductions.vue?vue&type=template&id=0d1b653e&scoped=true"
import script from "./AllProductions.vue?vue&type=script&lang=js"
export * from "./AllProductions.vue?vue&type=script&lang=js"

import "./AllProductions.vue?vue&type=style&index=0&id=0d1b653e&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d1b653e"]])

export default __exports__